import { useI18n } from "@/i18n/translations";
import { master } from "@/data/events";
import { Seo } from "@/components/Seo";
import { PageHeader, PdfLinkRow } from "@/components/Editorial";

export const Master = () => {
  const { t, lang } = useI18n();
  return (
    <>
      <Seo titleKey="seo.master.title" descKey="seo.master.desc" path="/attivita/master" />
      <PageHeader kickerKey="att.kicker" titleKey="att.master_title">
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mutedtx">{t("att.master_intro")}</p>
      </PageHeader>
      <div className="container-x pb-20 sm:pb-24">
        <div className="grid gap-6 md:grid-cols-2" data-testid="master-list">
          {master.map((m) => (
            <article key={m.id} className="flex flex-col gap-3 border border-borderc bg-cardwhite p-8" data-testid={`master-card-${m.id}`}>
              {m.poster && <img src={m.poster} alt={`Poster — ${lang === "en" && m.title.en ? m.title.en : m.title.it}`} className="img-treated mb-3 w-full border border-borderc object-cover" data-testid={`master-poster-${m.id}`} />}
              <span className="eyebrow text-bordeaux">{t("att.master_kicker")}</span>
              <h2 className="font-serif text-2xl font-medium leading-snug text-ink">{lang === "en" && m.title.en ? m.title.en : m.title.it}</h2>
              {m.description && <p className="text-sm leading-relaxed text-bodytx/85">{lang === "en" && m.description.en ? m.description.en : m.description.it}</p>}
              <div className="mt-auto flex flex-wrap gap-x-6 gap-y-2 pt-2">
                {m.pdfs.map((pdf, i) => (
                  <PdfLinkRow key={i} label={pdf.label} href={pdf.href} />
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </>
  );
};

export default Master;
